export default __webpack_public_path__ + "static/media/claw-machine.cd312408.png";